import React from 'react';

const Oklahoma = () => {
  return (
    <div>
      
    </div>
  );
}

export default Oklahoma;
